import { FadeUp, SectionTag } from "./Reveal";

const PHASES = [
    { n: "01", name: "Concept", status: "current" },
    { n: "02", name: "Prototype", status: "next" },
    { n: "03", name: "Vertical Slice", status: "future" },
    { n: "04", name: "Kickstarter", status: "future" },
    { n: "05", name: "Core Development", status: "future" },
    { n: "06", name: "Alpha", status: "future" },
    { n: "07", name: "Beta", status: "future" },
    { n: "08", name: "Launch", status: "future" },
];

const statusStyles = {
    done: "border-white/25 text-slate-400",
    current: "border-[#A855F7] text-white phantom-glow",
    next: "border-[#A855F7]/40 text-slate-200",
    future: "border-white/10 text-slate-500",
};

const dotStyles = {
    done: "bg-slate-400",
    current: "bg-[#A855F7] animate-pulse-dot",
    next: "bg-[#A855F7]/50",
    future: "bg-white/20",
};

const statusLabel = {
    done: "Complete",
    current: "In progress",
    next: "Up next",
    future: "Ahead",
};

export const Roadmap = () => (
    <section id="roadmap" className="relative py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionTag index="05" label="Development" />

            <FadeUp>
                <h2
                    data-testid="roadmap-heading"
                    className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl text-white leading-tight"
                >
                    The road from here{" "}
                    <span className="font-serif-accent italic font-medium text-[#C084FC]">
                        to launch.
                    </span>
                </h2>
            </FadeUp>
            <FadeUp delay={0.1}>
                <p className="mt-6 max-w-xl text-base text-slate-400 leading-relaxed">
                    We're early, and we're building honestly. This is the path we're on — no
                    dates we can't keep, no promises we can't prove.
                </p>
            </FadeUp>

            <div className="mt-16 relative">
                <span className="hidden lg:block absolute top-[52px] left-0 right-0 h-px bg-white/10" />
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
                    {PHASES.map((p, i) => (
                        <FadeUp key={p.n} delay={i * 0.07}>
                            <div
                                data-testid={`roadmap-phase-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`relative border bg-[#0A0A0F] p-5 pt-10 h-full transition-colors duration-500 ${statusStyles[p.status]}`}
                            >
                                <span
                                    className={`absolute top-6 left-5 w-2 h-2 rounded-full ${dotStyles[p.status]}`}
                                />
                                <span className="font-mono-meta text-[10px] tracking-[0.3em] text-slate-500 block">
                                    {p.n}
                                </span>
                                <h3 className="mt-3 font-display font-semibold text-sm sm:text-base leading-snug">
                                    {p.name}
                                </h3>
                                <span
                                    className={`mt-4 block font-mono-meta text-[9px] tracking-[0.25em] uppercase ${
                                        p.status === "current" ? "text-[#A855F7]" : "text-slate-600"
                                    }`}
                                >
                                    {statusLabel[p.status]}
                                </span>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
